import { FIELDS } from '../constants/fields';
const generateDropoffNode = index => ({
  dropoff: true,
  id: `not_stage${index}`
});
const injectDropoffNodes = columns => columns.map(({
  nodes
}, index) => ({
  nodes: index === 0 ? nodes : [...nodes, generateDropoffNode(index)]
}));
function buildNodeGenerator(aliasGenerator) {
  return (stage, dataset) => {
    const aliasesInDataset = dataset.data.reduce((aliasSet, row) => aliasSet.add(row[FIELDS.TO]), new Set());
    const candidateAliases = aliasGenerator(stage);
    return candidateAliases.reduce((acc, alias) => aliasesInDataset.has(alias) ? [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    ...acc, {
      id: alias
    }] : acc, []);
  };
}
const generateNodesFromPathfinder = buildNodeGenerator(({
  pathfinder,
  steps
}) => {
  const indicesAsArray = [...Array(pathfinder.numberOfStepsRequested).keys()];
  return steps.flatMap(step => step.breakdownField ? indicesAsArray.map(index => `${step.alias}_${index}`) : step.alias);
});
const generateNodesFromBreakdown = buildNodeGenerator(({
  breakdown,
  optional,
  steps
}) => {
  const baseAlias = steps[0].alias;
  const constructedAliases = [...Array(breakdown.numberOfStepsRequested).keys()].map(index => `${baseAlias}_${index}`);
  return optional ? [...constructedAliases, `${baseAlias}_shadow`] : constructedAliases;
});
const generateNodesForStage = (stage, dataset) => {
  if (stage.breakdown) {
    return generateNodesFromBreakdown(stage, dataset);
  } else if (stage.pathfinder) {
    return generateNodesFromPathfinder(stage, dataset);
  } else {
    return stage.steps.map(step => ({
      id: step.alias
    }));
  }
};
export const getNodeColumnsFromQuery = ({
  stages,
  includeDropoffs
}, datamap) => {
  const columnsFromSteps = stages.map(stage => ({
    nodes: generateNodesForStage(stage, datamap.primary)
  }));
  return includeDropoffs ? injectDropoffNodes(columnsFromSteps) : columnsFromSteps;
};
export const __TESTABLE__ = {
  generateDropoffNode,
  injectDropoffNodes,
  generateNodesFromBreakdown,
  generateNodesFromPathfinder
};